import React, { useState, useEffect } from "react"
import { Segmented } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFileExcel,
  faFilePowerpoint,
} from "@fortawesome/free-solid-svg-icons"
import { ReportingType } from "types/ReportingDashboard/reporting.types"

// Props interface
interface ReportingTypeSwitchProps {
  setReportingType: (type: ReportingType) => void
}

const ReportingTypeSwitch: React.FC<ReportingTypeSwitchProps> = ({
  setReportingType,
}) => {
  // Segmented value is the string 'excel' or 'dashboard'
  const handleChange = (value: string | number): void => {
    setReportingType(value as ReportingType) // Type assertion since we know the values
  }

  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(false)

  // Handle window resize
  useEffect(() => {
    const handleResize = (): void => {
      const width = window.innerWidth

      // Set responsive modes based on screen width
      const smallScreenBreakpoint = 1400 // Typical tablet landscape

      // Update screen size states
      const newIsSmallScreen = width < smallScreenBreakpoint

      setIsSmallScreen(newIsSmallScreen)
    }

    // Initial check
    handleResize()

    // Add event listener
    window.addEventListener("resize", handleResize)

    // Clean up
    return () => window.removeEventListener("resize", handleResize)
  }, [isSmallScreen]) // Only depend on previous small screen state

  return (
    <div className="inline-block relative">
      <div className="bg-white px-3 py-2.5 rounded-b-lg shadow-sm flex items-center">
        <Segmented
          options={[
            {
              label: (
                <div className="flex items-center gap-1.5 px-1">
                  <FontAwesomeIcon
                    icon={faFileExcel}
                    className="text-green-600"
                  />
                  <span>Report</span>
                </div>
              ),
              value: "excel",
            },
            {
              label: (
                <div className="flex items-center gap-1.5 px-1">
                  <FontAwesomeIcon
                    icon={faFilePowerpoint}
                    className="text-red-600"
                  />
                  <span>Dashboard</span>
                </div>
              ),
              value: "dashboard",
            },
          ]}
          defaultValue="dashboard"
          onChange={handleChange}
        />
      </div>
    </div>
  )
}

export default ReportingTypeSwitch
